import { useCallback } from 'react';
import { DropdownItem } from 'ui-components';
import { LinkIcon } from 'ui-components/dist/LinkIcon';
import { useWebLinksStore } from '~/screens/ManageWebLinks/useWebLinksStore';
import { ICreator } from '~/types';

interface Props {
  creator: ICreator;
}

export const WebLinksDropdownItem: React.FC<Props> = ({ creator }) => {
  const { showWebLinks } = useWebLinksStore();

  const onCreatorWebLinksClick = useCallback(
    (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
      event.stopPropagation();
      showWebLinks(creator);
    },
    [creator, showWebLinks],
  );

  return (
    <DropdownItem
      onClick={onCreatorWebLinksClick}
      trackId="foam-talent-menu-edit-weblinks"
    >
      <LinkIcon boxSize={4} />
      Links
    </DropdownItem>
  );
};
